import React from "react";
import { Link } from "react-router-dom";
import smart_home_saver from "../assets/smart_home_saver.png";
import g3t from "../assets/G3T.png";
import solent_ride_share from "../assets/solent_ride_share.png";
import solar_system from "../assets/solar_system.png";
import steady_paycheck from "../assets/steady_paycheck.png";
import portfolio from "../../src/assets/portfolio.png";
import connect_four from "../../src/assets/connect_four.png";
const Projects = () => {
  return (
    <div className="bg-gray-200 ">
      <h1 className=" text-bold sm:mb-4 sm:p-10 p-5 text-2xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
        My Projects
      </h1>
      <div class="grid gap-x-8 gap-y-4 sm:grid-cols-2 grid-cols-1 sm:p-10 p-6">
        {/* Smart Home Saver*/}
        <div className=" bg-lime-50 p-4 rounded-xl">
          <h2 className=" text-xl text-bold text-center mb-5">
            Smart Home Saver
          </h2>
          <Link
            to="https://smart-home-saver-frontend.onrender.com/"
            target="_blank"
          >
            <div className="flex justify-center ">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat"
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={smart_home_saver}
                  alt="Smart Home"
                  className=" mb-5 max-h-80  "
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center">
            Developed an interactive single-page web application called Smart
            Home Saver to provide personalised recommendations and guidance for
            buying and using affordable smart home devices to optimise energy
            efficiency.
          </h3>
          <h3 className="text-center mt-2">
            Technologies used: Javascript, HTML, CSS, NodeJS, ReactJS, Firebase,
            Web API (Netatmo, Phillips Hue, ChatGPT, OpenWeatherMap), Stripe
            Payments, Figma, Github.
          </h3>
        </div>

        {/* Solent Ride Share*/}
        <div className=" bg-gray-300 p-4 rounded-xl">
          <h2 className=" text-xl text-bold mb-5 text-center">
            Solent Ride Share
          </h2>
          <Link to="https://solent-ride-share.firebaseapp.com/" target="_blank">
            <div className="flex justify-center">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat"
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={solent_ride_share}
                  alt="Grand Stream Phones"
                  className=" mb-9 max-h-80 "
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center ">
            The Solent Ride Share Single Page Application is a web application
            designed to improve the commuting experience of Solent University
            students. This application allows students to find and share rides,
            split transportation costs, and access a range of features that
            enhance their daily commute.
          </h3>
          <h3 className="text-center mt-2">
            Technologies used: Javascript, HTML, CSS, ReactJS, Firebase, Figma,
            Github.
          </h3>
        </div>

        {/* G3T Phones application*/}
        <div className=" bg-blue-100 p-4 rounded-xl">
          <h2 className=" text-xl text-bold mb-5 text-center">
            Online Configuration System for Grand Stream SIP Phones
          </h2>
          <Link to="#">
            <div className="flex justify-center">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat"
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={g3t}
                  alt="Grand Stream Phones"
                  className="mb-9 min-h-80"
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center">
            This project aimed to create an automated, user-friendly web
            application to optimise the configuration process for Grand Stream
            SIP phones. The system was developed as part of the Industrial
            Consulting Project at Solent University
          </h3>
          <h3 className="text-center mt-2">
            Technologies used: Javascript, HTML, CSS, SQL, NodeJS, ReactJS, XML,
            Bycript, JsonWebToken, Github.
          </h3>
        </div>

        {/* Solar System */}
        <div className=" bg-orange-100 p-4 rounded-xl">
          <h2 className=" text-xl text-bold mb-5 text-center">
            The Solar System Application (Python)
          </h2>
          <Link
            to="https://github.com/MariusBaldovin/Solar-System-Application-Python"
            target="_blank"
          >
            <div className="flex justify-center">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat "
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={solar_system}
                  alt="Grand Stream Phones"
                  className="mb-9 min-h-80 "
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-80 w-full overflow-hidden bg-[#413f3f33] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100 "></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center">
            Developed a Python application to simulate real-world problem
            scenarios within the solar system. Utilised fundamental programming
            concepts such as standard user input, built-in functions, variables,
            data types, booleans, strings, and numbers. Implemented organisation
            and manipulation of data, including both ordered and unordered data
            structures. Incorporated data visualisation techniques such as
            plotting charts. Applied principles of object-oriented programming,
            including the creation and utilisation of classes and arguments.
          </h3>
        </div>

        {/* Steady Paycheck */}
        <div className=" bg-sky-50 p-4 rounded-xl">
          <h2 className=" text-xl text-bold mb-5 text-center">
            Steady Paycheck
          </h2>
          <Link
            to="https://www.figma.com/file/yyEZn2kvjJiWa8ae45pBaW/Steady-Paycheck-(SP)?type=design&node-id=0%3A1&mode=design&t=vlTn4pHCPCxRxgiC-1"
            target="_blank"
          >
            <div className="flex justify-center">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat"
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={steady_paycheck}
                  alt="Grand Stream Phones"
                  className=" mb-9 max-h-80 "
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center">
            Developed a mobile application prototype for Steady Paycheck (SP), a
            recruitment agency acting as an intermediary between employers and
            job seekers. The main objective was to design and develop an
            intuitive interface for various functionalities including
            interaction with the complete system (company main interface),
            search job screen, sign up screen (for both job seekers and
            employers), uploading CV, profile screen, and job description
            screen. The prototype was created using Figma.
          </h3>
        </div>
        {/* Portfolio */}
        <div className=" bg-indigo-50 p-4 rounded-xl">
          <h2 className=" text-xl text-bold mb-5 text-center">Portfolio</h2>
          <Link to="" target="_blank">
            <div className="flex justify-center">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat"
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={portfolio}
                  alt="Portfolio"
                  className=" mb-9 max-h-80 "
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center">
            Developed a portfolio web application in ReactJS framework using
            TailwindCSS for styling aiming to showcase my skills, projects, CV,
            and provide a means of contact.
          </h3>
          <h3 className="text-center mt-2">
            Technologies used: Javascript, HTML, TailwindCSS, ReactJS, EmailJS,
            Github.
          </h3>
        </div>
        {/* Connect Four */}
        <div className=" bg-fuchsia-50 p-4 rounded-xl">
          <h2 className=" text-xl text-bold mb-5 text-center">Connect Four</h2>
          <Link to="https://connect-four-pyyx.onrender.com/" target="_blank">
            <div className="flex justify-center">
              <div
                className="relative  overflow-hidden bg-cover bg-no-repeat"
                data-twe-ripple-init
                data-twe-ripple-color="light"
              >
                <img
                  src={connect_four}
                  alt="Connect Four"
                  className=" mb-9 max-h-80 "
                />
                <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
              </div>
            </div>
          </Link>
          <h3 className="text-center">
            Developed a connect four game in ReactJS framework using TailwindCSS
            for styling.
          </h3>
          <h3 className="text-center mt-2">
            Technologies used: Javascript, HTML, TailwindCSS, ReactJS, Github.
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Projects;
